import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Driver,
  CreateDriverRequest,
  UpdateDriverRequest,
  DriversListParams,
  DriverAvailability
} from '../types';

const { DRIVERS } = API_ENDPOINTS;

export const driversApi = {
  getAll: (params?: DriversListParams) =>
    apiClient.getPaginated<Driver>(DRIVERS.LIST, params),

  getById: (id: number) => apiClient.get<Driver>(DRIVERS.GET(id)),

  create: (data: CreateDriverRequest) =>
    apiClient.post<Driver>(DRIVERS.CREATE, data),

  update: (id: number, data: UpdateDriverRequest) =>
    apiClient.put<Driver>(DRIVERS.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(DRIVERS.DELETE(id)),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<DriversListParams> }
  ) => apiClient.post(DRIVERS.BULK_DELETE, params),

  updateAvailability: (id: number, status: DriverAvailability) =>
    apiClient.patch<Driver>(DRIVERS.AVAILABILITY(id), { status })
};
